import React from "react";
import { LoadingStyled } from "./style";
var Loading = function () {
    return (React.createElement(LoadingStyled, null,
        React.createElement("div", { className: "loadingio-spinner-dual-ring-0vpzkyvcrwt" },
            React.createElement("div", { className: "ldio-w25ajxc6pq" },
                React.createElement("div", null),
                React.createElement("div", null,
                    React.createElement("div", null))))));
};
export default Loading;
